import { Api } from '@/api'

export function useApi() {
  const {
    public: { apiBase },
  } = useRuntimeConfig()

  return new Api({
    baseUrl: apiBase,
    customFetch: (url, init) => {
      const headers = new Headers(init?.headers)

      if (!headers.has('X-Region-Id')) {
        try {
          const directoryStore = useDirectoryStore()
          const regionId = directoryStore.regionId
          if (regionId) {
            headers.set('X-Region-Id', regionId)
          }
        } catch {
          // стора может быть недоступна на раннем этапе — пропускаем
        }
      }

      return fetch(url, { ...init, headers })
    },
  })
}
